import {QueryKey} from '@config/queryKeys';
import LiveEventService from '@services/live-event/live-event.service';
import {useQuery} from '@tanstack/react-query';
import {useCurrentLiveEventSlug} from './useCurrentLiveEventSlug';

export const useLiveEventQuery = () => {
    const slug = useCurrentLiveEventSlug();
    const query = useQuery({
        queryKey: QueryKey.LIVE_EVENT(slug),
        queryFn: async () => await LiveEventService.getLiveEvent(slug),
    });

    return {query};
};
